import { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface WindowFrameProps {
  children: ReactNode
  className?: string
}

export const WindowFrame = ({ children, className }: WindowFrameProps) => {
  return (
    <div
      className={cn(
        'relative bg-[#cccccc] rounded-lg retro-window-shadow retro-bevel-outset overflow-hidden flex flex-col max-w-7xl w-full mx-auto aspect-[4/3] max-h-[90vh]',
        className,
      )}
    >
      {/* Stripe Lines Decoration */}
      <div className="absolute top-1 left-2 right-2 h-[2px] bg-white opacity-50 pointer-events-none z-20"></div>
      <div className="absolute top-2 left-2 right-2 h-[1px] bg-gray-400 opacity-50 pointer-events-none z-20"></div>

      {children}
    </div>
  )
}
